import { createContext } from 'react'

const TasasContext = createContext();

export default TasasContext;